module.exports = __webpack_public_path__ + "static/media/partners-hero-m.7e7902db.webp";